import React from 'react';
import { ChosenMetric } from '@/components/SummarizeMetrics/subcomponents/ChosenMetric';
import InlineAggregateLayer from '@/components/layers/InlineAggregateLayer';
import { MetricColumnsDropdownList } from '@/components/SummarizeMetrics/subcomponents/MetricColumnsDropdownList';
import { CUSTOMIZE_AGGREGATE_CLICKED } from '@/actions/constants';
import { useAppDispatch } from '@/store/hooks';
import { completed } from '@/actions/helpers';
import flex from '../../css/module/flex.css';
import AggregateFunction from '../../util/AggregateFunction';
import TableRef from '../../util/TableRef';
import NewWorldColumn from '../../util/NewWorldColumn';

export type SummarizeMetricsProps = {
  aliases: Record<string, TableRef>;
  columns: NewWorldColumn[];
  getTableOrInsightName: F2<string, boolean, string>;
  metrics: AggregateFunction[];
  setState: F<unknown>;
  currentLayer: InlineAggregateLayer;
};

export const SummarizeMetrics: React.FC<SummarizeMetricsProps> = ({
  columns,
  getTableOrInsightName,
  setState,
  metrics,
  aliases,
  currentLayer,
}) => {
  const dispatch = useAppDispatch();

  // build aggregate function and update state when metrics are selected
  const selectMetrics = (newAggregateFunction: AggregateFunction) =>
    setState({
      metrics: [...metrics, newAggregateFunction],
    });

  const openModal = (
    aggregateFunction: AggregateFunction,
    selectedMetric?: number,
  ) => {
    dispatch(
      completed(CUSTOMIZE_AGGREGATE_CLICKED, {
        aggregateFunction,
        columns,
        getTableOrInsightName,
        currentLayer,
        selectedMetric,
        clauses: aggregateFunction.clauses,
      }),
    );
  };

  const buildMetric = (m: AggregateFunction, i: number) => {
    return (
      <ChosenMetric
        key={`metric_${i}`}
        aggregateFunction={m}
        onClick={() => openModal(m, i)}
        onDelete={() => deleteMetric(i)}
        aliases={aliases}
        editable
      />
    );
  };

  const chosenMetrics = () => {
    return metrics.map(buildMetric);
  };

  // delete a metric using the position in the array
  const deleteMetric = (position: number) => {
    const copyOfArray = metrics.slice();
    copyOfArray.splice(position, 1);
    setState({
      metrics: copyOfArray,
    });
  };

  return (
    <div className={`${flex.alignItemsCenter} ${flex.wrap}`}>
      <span className="margin-right-5">Metrics</span>
      <div className={`${flex.alignItemsCenter} ${flex.wrap}`}>
        {chosenMetrics()}
        <MetricColumnsDropdownList
          columns={columns}
          getTableOrInsightName={getTableOrInsightName}
          onSelectMetric={selectMetrics}
          openModal={openModal}
          showCustomizeButton
        />
      </div>
    </div>
  );
};

export default SummarizeMetrics;
